function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15329_1705)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63.7148 111.948L186.755 98.3785L307.75 105.052L197.601 122.663L63.7148 111.948Z",
  fill: "#84D9F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M303.682 251.212L197.738 287.459V150.623L303.682 126.789V251.212Z",
  fill: "#B0E7FA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.796 287.459L74.04 257.399V137.133L197.796 150.725V287.459Z",
  fill: "#84D9F6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.601 155.491L63.7148 139.831V111.948L197.601 122.663V155.491Z",
  fill: "#E4F8FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M308.137 134.434L197.603 155.721V122.663L307.75 105.052L308.137 134.434Z",
  fill: "#CEF2FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.354 275.961L123.755 269.39V116.545L150.354 118.744V275.961Z",
  fill: "#CDDBFE"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.853 263.477L241.125 272.511V115.622L267.853 111.273V263.477Z",
  fill: "#9FB4F9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.755 116.545L225.631 100.556L255.587 102.154L150.354 118.743L123.755 116.545Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M267.852 111.273L156.937 101.555L129.565 104.752L241.124 115.622L267.852 111.273Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.356 109.35C163.535 93.3864 140.683 79.3546 148.137 70.662C150.913 67.4245 156.301 67.0932 159.73 69.7996C168.777 76.9461 184.212 95.127 197.356 109.35Z",
  fill: "#5D70CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.356 109.35C164.35 108.813 138.649 107.571 127.396 104.933C123.659 104.056 121.009 101.146 120.826 97.7441C119.99 82.2398 140.072 64.1291 156.917 68.4271C137.918 70.2256 155.938 87.0392 197.356 109.352V109.35Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.598 109.35C231.984 90.7255 258.332 74.7305 235.658 66.7759C226.587 66.8267 207.07 91.7474 189.598 109.35Z",
  fill: "#5D70CC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.598 109.35C225.054 108.813 252.661 107.571 264.75 104.933C268.763 104.056 271.61 101.146 271.807 97.744C272.704 82.2398 259.487 65.328 235.658 66.7776C251.644 72.2344 234.088 87.0392 189.598 109.352V109.35Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M188.443 100.156L198.901 99.2568L199.547 111.648L184.31 111.848L188.443 100.156Z",
  fill: "#8099F5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.072 48.4454C138.521 54.1126 135.629 57.9944 130.448 60.1329L123.896 55.4337C128.699 55.3201 131.976 51.8506 133.231 43.924L139.072 48.4454Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.748 86.571C148.974 89.675 144.136 89.8404 139.233 87.1241L138.818 79.0715C141.905 82.7533 146.662 83.1509 153.639 79.1851L153.75 86.571H153.748Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.7009 98.8363C72.9269 101.94 68.0888 102.106 63.1864 99.3895L62.7715 91.3369C65.8586 95.0187 70.6153 95.4163 77.5922 91.4504L77.7033 98.8363H77.7009Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.849 86.1265C115.228 84.2571 119.965 85.2572 124.075 89.0675L122.546 96.9843C120.432 92.6703 115.91 91.1442 108.185 93.3222L109.847 86.1265H109.849Z",
  fill: "#EDCCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M129.915 23.444C124.647 21.2833 121.763 17.3965 121.207 11.8182L127.596 6.89917C126.322 11.5317 128.698 15.6704 135.926 19.1547L129.913 23.444H129.915Z",
  fill: "#EDCCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110.27 71.7696C105.489 74.8637 100.651 75.0143 95.7536 72.2882L95.3584 64.2355C98.4357 67.9248 103.192 68.3347 110.177 64.3862L110.27 71.7721V71.7696Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.3623 125.093C42.1957 122.698 39.4864 118.685 39.1826 113.09L45.7866 108.462C44.3048 113.033 46.4954 117.273 53.5612 121.078L47.3623 125.093Z",
  fill: "#EDCCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.3807 140.947C71.8769 146.619 69.0195 150.525 63.8553 152.706L57.2637 148.061C62.0648 147.905 65.3149 144.409 66.5004 136.474L72.3807 140.947Z",
  fill: "#EDCCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.747 168.048C100.677 173.352 96.8392 176.303 91.2725 176.953L86.2441 170.651C90.8971 171.846 94.9968 169.396 98.3556 162.109L102.749 168.048H102.747Z",
  fill: "#EDCCFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.7165 186.976C12.3054 185.2 9.14914 181.531 8.19336 176.009L14.212 170.643C13.2735 175.355 15.9433 179.311 23.4043 182.267L17.7165 186.978V186.976Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.713 43.2755C104.448 47.9401 100.022 49.9033 94.4579 49.2192L91.0596 41.9074C95.3001 44.1669 99.8591 42.7569 104.845 36.4674L107.713 43.2755Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M184.446 38.0058C181.181 42.6705 176.756 44.6336 171.191 43.9496L167.793 36.6378C172.033 38.8973 176.593 37.4872 181.579 31.1978L184.446 38.0058Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.4188 66.2333C76.1115 66.4061 80.1766 69.0311 82.6562 74.0587L78.4034 80.9088C77.9687 76.1231 74.2888 73.0858 66.2969 72.3623L70.4188 66.2333Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.2195 133.153C21.6726 134.442 17.069 132.943 13.3867 128.718L15.7453 121.009C17.3876 125.523 21.7244 127.521 29.6349 126.175L27.2171 133.153H27.2195Z",
  fill: "#DE9EFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.8153 41.4456C69.5504 46.1103 65.1247 48.0734 59.5604 47.3894L56.1621 40.0776C60.4026 42.3371 64.9617 40.9271 69.948 34.6376L72.8153 41.4456Z",
  fill: "#EDCCFF"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15329_1705"
}, /*#__PURE__*/React.createElement("rect", {
  width: 346,
  height: 287,
  fill: "white"
})));

function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 287,
    viewBox: "0 0 346 287",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/Illustration.d18e24c23c65e32bfef01dd47a6c104c.svg";
export { ForwardRef as ReactComponent };